/* @flow */

const exported = {
    setParam(
        values: {
            [x: string]: any;
        },
        router: {
            [x: string]: any;
        },
        location: {
            [x: string]: any;
        }
    ) {
        const path = location.pathname;
        const query = Object.assign({}, location.query, values);
        router.replace({ pathname: path, query, state: location.state });
    },

    getParam(
        key: string,
        location: {
            [x: string]: any;
        }
    ) {
        const query = location.query;
        return query ? query[key] : query;
    },

    extractCategoryIds(location: { [x: string]: any }): { [catId: string]: boolean } {
        const query = location.query;
        return Object.entries(query)
            .filter(([key]) => key.startsWith("cat_"))
            .reduce((obj, [key, value]) => {
                return {
                    ...obj,
                    [key]: value
                };
            }, {});
    },

    redirectToSearch(
        searchParams: {
            [x: string]: any;
        },
        router: {
            [x: string]: any;
        }
    ) {
        if (searchParams.q || searchParams.facets) {
            router.push({ pathname: "/search", query: searchParams, state: {} });
        }
    },

    redirectToCategory(
        categoryPath: string | undefined | null,
        router: {
            [x: string]: any;
        },
        query?: string | undefined | null
    ) {
        if (categoryPath) {
            if (query) {
                router.push({ pathname: "/category/" + categoryPath, query: { q: query } });
            } else {
                router.push({ pathname: "/category/" + categoryPath });
            }
        }
    },

    getLinkForOrderFulfillmentRoute(url: string): string {
        return "/orderfulfillment.uidispatcher.static/backend#" + url;
    }
};

export default exported;

export const { setParam, getParam, redirectToSearch, redirectToCategory, getLinkForOrderFulfillmentRoute } = exported;
